import React, { Fragment, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import cn from 'classnames';

import Header from 'components/Header';
import Footer from 'components/Footer';
import circleDeclined from 'assets/icons/circle-declined.svg';

import style from './style.scss';

const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const [searchParams] = useParams();

  useEffect(() => {
    const key = searchParams.get('key');
    if (!key) {
      navigate(`/applications/${params.workflowtype}/application`);
    }
  }, []);

  return (
    <Fragment>
      <Header />
      <section className={cn('grid-container fluid section', style['borrowers-message'])}>
        <div className="grid-container">
          <div className="grid-x grid-margin-x max-limited">
            <div className="cell small-12 large-8 large-offset-2">
              <img src={circleDeclined} alt="Circle Declined" />
              <h2>{location.state.message}</h2>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};

export default ErrorPage;
